import { createFileRoute } from '@tanstack/react-router'

import { GuaranteesPageSkeleton } from '#/modules/guarantee/front-office/guarantees-page/guarantees-page-skeleton.tsx'
import { GuaranteesPage } from '#/modules/guarantee/front-office/guarantees-page/guarantees-page.tsx'

export const Route = createFileRoute('/(customer)/_shell/contract-guarantees-v2/')({
  loader: async ({ context }) => {
    const { queryClient, trpc } = context
    void queryClient.prefetchQuery(trpc.invoices.hasUnpaidInvoices.queryOptions())
    await queryClient.ensureQueryData(trpc.contracts.listMyContracts.queryOptions())
  },
  pendingComponent: GuaranteesPageSkeleton,
  pendingMs: 150,
  component: GuaranteesPage,
})
